import { BlogSection } from '@/types/blog';

export const limitationsSection: BlogSection = {
  id: 'grenzen-herausforderungen',
  title: 'Grenzen und Herausforderungen',
  content: `
    <p>
      Trotz aller Begeisterung möchte ich auch auf die Grenzen und Herausforderungen hinweisen:
    </p>
    
    <ul class="my-4 space-y-2">
      <li class="flex items-start">
        <span class="text-primary mr-2">⚠️</span>
        <span>Komplexe Spezialfunktionen erfordern manchmal mehrere Iterationen und präzise Anleitung</span>
      </li>
      <li class="flex items-start">
        <span class="text-primary mr-2">⚠️</span>
        <span>Bei sehr spezifischen technischen Anforderungen stößt die KI gelegentlich an Grenzen</span>
      </li>
      <li class="flex items-start">
        <span class="text-primary mr-2">⚠️</span>
        <span>Die Kommunikation mit einer KI erfordert eine gewisse Einarbeitungszeit und klare Formulierungen</span>
      </li>
    </ul>
    
    <h3>Ehrliche Einschätzung meiner Erfahrung</h3>
    
    <p>
      Ich muss ehrlich sein: Meine Programmierkenntnisse aus früheren Jahren haben das Lernen beschleunigt und die 
      Fehlersuche erleichtert. Durch die Begeisterung für die neuen Möglichkeiten habe ich viel experimentiert, 
      was manchmal zu Rückschritten führte – Inhalte mussten wieder zurückgebaut werden, weil sie zu komplex wurden.
    </p>
    
    <p>
      Für jemanden ohne jegliche Programmiererfahrung wäre der Einstieg vermutlich herausfordernder gewesen. 
      Allerdings hat sich die Plattform seit Beginn meines Projekts kontinuierlich verbessert und wird immer 
      benutzerfreundlicher – ein Vorteil der rasanten Entwicklung im KI-Bereich.
    </p>
    
    <p>
      Es ist wichtig zu verstehen, dass die KI ein mächtiges Werkzeug ist, aber kein vollständiger Ersatz für 
      menschliche Kreativität und strategisches Denken. Die besten Ergebnisse entstehen, wenn man die Stärken 
      der KI gezielt einsetzt und gleichzeitig klare Vorstellungen vom gewünschten Ergebnis hat.
    </p>
  `
};
